module.exports = __webpack_public_path__ + "media/img/features/secret-url-languages-thumb-995a92d1b0f47bdfa703ed84d1543a70.png";